import {
  Account,
  replaceMentionPlaceholderWithNames,
} from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { Clipboard, Platform } from 'react-native';
import Toast from 'react-native-toast-message';

/**
 * Copies a message as the reader sees it: mentions as names rather than the
 * stored `@[Name](accountId)` markup, which would paste an internal account id
 * into wherever it lands.
 */
export const useCopyMessage = () => {
  const { t } = useTranslation();

  return async (text?: string | null, mentions?: Account[] | null) => {
    if (!text) return;
    const resolved = replaceMentionPlaceholderWithNames(
      text,
      mentions ?? [],
      t('mentions.unknownUser'),
      true
    );
    try {
      if (Platform.OS === 'web') {
        await navigator.clipboard.writeText(resolved);
      } else {
        Clipboard.setString(resolved);
      }
      Toast.show({ type: 'success', text1: t('chat.thread.copied') });
    } catch (error) {
      Toast.show({ type: 'error', text1: t('chat.thread.copyError') });
    }
  };
};
